<template>
  <ul class="masonry-gallery__tabs">
    <li
      v-for="tab in tabs"
      :key="tab.value"
      :class="{ active: activeTab === tab.value }"
    >
      <button type="button" @click="onTabClick(tab.value)">
        <span class="masonry-gallery__link-text">{{ tab.name }}</span>
      </button>
    </li>
  </ul>

  <KeepAlive :key="activeTab">
    <MasonryGallery
      :images="activeImages"
      :targetId="targetId"
      :onImageClick="openLightbox"
    />
  </KeepAlive>

  <LightBox
    :images="activeImages"
    :slideIndex="selectedImageIndex"
    :targetId="targetId"
    loop
  />
</template>

<script>
import LightBox from "@/components/common/modals/LightBox";
import MasonryGallery from "./MasonryGallery.vue";

export default {
  name: "PhotoGallery",
  components: {
    LightBox,
    MasonryGallery,
  },
  props: {
    images: Object,
    tabs: Array,
  },
  data() {
    return {
      selectedImageIndex: 0,
      activeTab: "",
    };
  },
  beforeMount() {
    this.targetId = `masonry-modal-${Math.random().toString().slice(2, 9)}`;
    const activeTab = this.tabs.find((tab) => tab.isActive);
    this.activeTab = activeTab ? activeTab.value : null;
  },
  computed: {
    activeImages() {
      if (!this.activeTab) {
        return this.allImages;
      }

      return this.images[this.activeTab] || [];
    },
    allImages() {
      if(!this.tabs?.length) return [];
      const allImages = this.tabs.map(tab => this.images[tab.value] || []).flat().filter(item => item)
      return allImages
    },
  },
  methods: {
    openLightbox(index) {
      this.selectedImageIndex = index;
    },
    onTabClick(value) {
      const tabValue = this.activeTab === value ? null : value;
      this.activeTab = tabValue;
      this.updateQuery(tabValue);
    },
    updateQuery(selectedCategory) {
      const url = new URL(window.location);

      if (selectedCategory) {
        url.searchParams.set("selectedCategory", selectedCategory);
      } else {
        url.searchParams.delete("selectedCategory");
      }

      window.history.pushState({}, "", url);
    },
  },
};
</script>
